import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaClock, FaMapMarkerAlt, FaHourglassStart } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import Swal from "sweetalert2";
const TrainersContest = () => {
  const [appliedContest, setAppliedContest] = useState(null);
  const [contests, setContests] = useState([]);
  const [contestsVideo, setVideoContests] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [urlInput, setUrlInput] = useState("");
  const [selectedContest, setSelectedContest] = useState(null); // Store a single contest ID
  const [selectedVideoLink, setSelectedVideoLink] = useState(null);
  const member_id = sessionStorage.getItem("member_id");
  const [members, setMember] = useState([]);
  const transformToEmbedUrl = (url) => {
    // YouTube Embed
    if (url.includes("youtube.com/shorts/")) {
      const videoId = url.split("/shorts/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    if (url.includes("youtube.com/watch?v=")) {
      const videoId = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Handle YouTube short URL (youtu.be format)
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Vimeo Embed
    if (url.includes("vimeo.com/")) {
      const videoId = url.split("vimeo.com/")[1];
      return `https://player.vimeo.com/video/${videoId}`;
    }

    // Dailymotion Embed
    if (url.includes("dailymotion.com/video/")) {
      const videoId = url.split("dailymotion.com/video/")[1].split("_")[0];
      return `https://www.dailymotion.com/embed/video/${videoId}`;
    }

    // Instagram Embed (Posts only, not reels or videos)
    if (url.includes("instagram.com/p/")) {
      const shortcode = url.split("instagram.com/p/")[1].split("/")[0];
      return `https://www.instagram.com/embed/${shortcode}`;
    }

    // Instagram Video or Reel: Open in a new tab
    if (
      url.includes("instagram.com/reel/") ||
      url.includes("instagram.com/tv/")
    ) {
      window.open(url, "_blank");
      return null; // Return null to indicate no embed URL
    }

    // Facebook Video: Open in a new tab
    if (
      url.includes("facebook.com/watch/") ||
      url.includes("facebook.com/video/")
    ) {
      window.open(url, "_blank");
      return null; // Return null to indicate no embed URL
    }

    // Return original URL if no match
    return url;
  };

  const handleVideoClick = (link) => {
    const embedLink = transformToEmbedUrl(link);
    setSelectedVideoLink(embedLink); // Set the transformed embed link
  };
  const handleApply = (contestId) => {
    setSelectedContest(contestId); // Update to store a single contest ID
    setIsModalOpen(true);
  };

  const fetchContests = async () => {
    try {
      const response = await axios.get("/contests/get_all");
      setContests(response.data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };
  const fetchContestsVideo = async () => {
    try {
      const response = await axios.get("/contests/get_all_video");
      setVideoContests(response.data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };
  const fetchMember = async () => {
    try {
      const response = await axios.get("/member/get_all_member");
      setMember(response.data);
    } catch (error) {
      console.error("Error fetching member:", error);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setUrlInput("");
  };

  const handleSubmit = async () => {
    if (selectedContest) {
      const contestIdToSend = selectedContest; // Use the selected contest ID
      console.log("Submitting URL:", urlInput);
      console.log("Contest ID to send:", contestIdToSend);

      try {
        // Send the selected contest ID and URL to the backend
        await axios.put("/contests/update", {
          contest_id: contestIdToSend,
          url: urlInput,
          jci_member_id: member_id,
        });

        // Mark the contest as applied
        setAppliedContest(contestIdToSend);
        handleModalClose();

        // Show SweetAlert after successful submission
        Swal.fire({
          title: "Success!",
          text: "The URL has been submitted successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        console.error("Error submitting contest data:", error);

        // Show SweetAlert for error
        Swal.fire({
          title: "Error!",
          text: "There was an issue submitting the URL.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    }
  };

  useEffect(() => {
    fetchContests();
    fetchContestsVideo();
    fetchMember();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-semibold text-gray-900 dark:text-white">
            Contest
          </h1>
          <h6 className="text-sm font-bold text-[#b6b7ba] dark:text-[#b6b7ba] mt-2">
            See your scheduled contests from your calendar.
          </h6>
        </div>
        <div className="p-4">
          <h2 className="text-xl font-semibold">Apply for Upcoming Contests</h2>
          <p className="mt-2 text-gray-700 dark:text-gray-300">
            Here are the upcoming contests scheduled in your calendar:
          </p>

          <div className="mt-16 md:mt-4">
            {contests.map((contest) => {
             const date = new Date(contest.contest_last_date_to_apply);
             const formattedDate = `${String(date.getUTCDate()).padStart(2, '0')}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${date.getUTCFullYear()}`;
             
              
              const matchingVideo = contestsVideo.find(
                (contest_video) =>
                  contest_video.contest_id === contest.contest_id &&
                  contest_video.jci_member_id === member_id
              );

              return (
                <div
                  key={contest.contest_id}
                  className="grid grid-cols-1 md:grid-cols-6 gap-4 p-4 border rounded-lg hover:bg-[#f8f8f8] mb-2"
                >
                  {/* Contest Title Section */}
                  <div className="font-semibold text-lg md:border-r pr-4 mb-4 md:mb-0 text-center md:text-left">
                    <p className="text-[#3b3b3b] mt-2">
                      {contest.contest_title}
                    </p>
                  </div>

                  {/* Contest Description Section */}
                  <div className="pl-4 mb-4 md:mb-0">
                    <div className="flex items-center mb-2">
                      <span className="text-[#838383] font-bold text-sm">
                        {contest.contest_description}
                      </span>
                    </div>
                  </div>
                  <div className="pl-4 mb-4 md:mb-0">
                    <div className="flex items-center mb-2">
                      <span className="text-[#838383] font-bold text-sm">
                        {matchingVideo && matchingVideo.video_link ? (
                          <a
                            onClick={() =>
                              handleVideoClick(matchingVideo.video_link)
                            }
                            className="text-blue-500 underline hover:text-blue-700"
                          >
                            View Link
                          </a>
                        ) : (
                          <span className="text-red-500">N/A</span>
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Last Date Section */}
                  <div className="font-bold text-sm mb-4 md:mb-0 text-center md:text-left">
                    <div className="flex items-center justify-center md:justify-start mb-2">
                      <p className="text-[#ea3c3c]">Last Date to Apply</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <MdDateRange className="mr-2 text-[#93979a]" />
                      <span className="text-[#838383] font-bold text-sm">
                        {formattedDate}
                      </span>
                    </div>
                  </div>

                  {/* Button Section */}
                  <div className="col-span-1 md:col-span-2 text-right mt-10 flex flex-col md:flex-row md:justify-end">
                    <button
                      className={`mb-2 md:mb-0 md:mr-2 ${
                        contestsVideo.some(
                          (video) =>
                            video.contest_id === contest.contest_id &&
                            video.video_link &&
                            video.jci_member_id === member_id
                        )
                          ? "bg-green-600 text-white cursor-not-allowed"
                          : "bg-black text-white hover:bg-gray-800"
                      } p-2 rounded-lg w-full md:w-auto`}
                      onClick={() => handleApply(contest.contest_id)}
                      disabled={contestsVideo.some(
                        (video) =>
                          video.contest_id === contest.contest_id &&
                          video.video_link &&
                          video.jci_member_id === member_id
                      )}
                    >
                      {contestsVideo.some(
                        (video) =>
                          video.contest_id === contest.contest_id &&
                          video.video_link &&
                          video.jci_member_id === member_id
                      )
                        ? "Added Successfully"
                        : "Add"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-96">
              <h2 className="text-xl font-semibold mb-4">Enter URL</h2>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded-lg mb-4"
                placeholder="Enter URL here..."
                value={urlInput}
                onChange={(e) => setUrlInput(e.target.value)}
              />
              <div className="flex justify-end">
                <button
                  className="bg-gray-500 text-white px-4 py-2 rounded-lg mr-2"
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {selectedVideoLink && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-5 rounded-lg shadow-lg">
              <iframe
                width="560"
                height="315"
                src={selectedVideoLink}
                title="Video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <button
                onClick={() => setSelectedVideoLink(null)}
                className="mt-2 px-4 py-2 bg-gray-600 text-white rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrainersContest;
